import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { LoadingSpinner } from "@vfit/shared/atoms";
import { Container, Title } from "./iframeDetail.style";
var IframeDetail = function(param) {
    var title = param.title, url = param.url, options = param.options;
    var ref = useState(true), isLoading = ref[0], setIsLoading = ref[1];
    return /*#__PURE__*/ _jsx(Container, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "iframe-holder",
            children: [
                title && /*#__PURE__*/ _jsx(Title, {
                    textAlign: options === null || options === void 0 ? void 0 : options.textAlign,
                    children: title
                }),
                isLoading && /*#__PURE__*/ _jsx(LoadingSpinner, {}),
                /*#__PURE__*/ _jsx("iframe", {
                    src: url,
                    title: title || "",
                    onLoad: function() {
                        return setIsLoading(false);
                    },
                    frameBorder: 0,
                    style: {
                        width: "100%",
                        height: "99%"
                    }
                })
            ]
        })
    });
};
export default IframeDetail;
